import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import app from "./app";
import config from "./config";
import home from "../../home/reducers";
import auth from "../../auth/reducers";
import stock from "../../stock/reducers";
import users from "../../users/reducers";
import profiles from "../../profiles/reducers";
import company from "../../company/reducers";
import transmissionValidator from "../../transmissionValidator/reducers";
import vehicles from '../../vehicles/reducers';
import store from '../../store/reducers';
import historicalInfo from '../../historicalInfo/reducers';
import activeServices from '../../activeServices/reducers';
import reports from '../../reports/reducers';
import renewalConfigs from '../../renewalConfigs/reducers';
import dealers from '../../dealers/reducers';
import deviceCommands from '../../deviceCommands/reducers';

const persistConfig = {
    key: "root",
    storage,
    blacklist: [
        "app",
        "stock",
        "users",
        "company",
        "transmissionValidator",
        "vehicles",
        "store",
        "historicalInfo",
        "activeServices",
        "reports",
        "renewalConfigs",
        "dealers",
        "deviceCommands"
    ],
    whitelist: [
        "config",
        "home",
        "auth",
        "profiles"
    ]
};

const rootReducer = combineReducers({
    app,
    config,
    home,
    auth,
    stock,
    users,
    profiles,
    company,
    transmissionValidator,
    vehicles,
    store,
    historicalInfo,
    activeServices,
    reports,
    renewalConfigs,
    dealers,
    deviceCommands
});

export default persistReducer(persistConfig, rootReducer);
